import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CallCenterPortalService {
  constructor(private http: HttpClient) {}

  public getUrl(): Observable<any> {
    const path = 'api/communication/call-center/login-as-agent';
    return this.http.get(path);
  }
}
